/**
 * Calculate optimal popup position to stay within viewport
 * @param {number} clientX - Mouse X position
 * @param {number} clientY - Mouse Y position
 * @param {number} popupWidth - Popup width
 * @param {number} popupHeight - Popup height
 * @returns {object} Adjusted position
 */
export function calculatePopupPosition(
  clientX,
  clientY,
  popupWidth,
  popupHeight
) {
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;
  const scrollX = window.pageXOffset || document.documentElement.scrollLeft;
  const scrollY = window.pageYOffset || document.documentElement.scrollTop;

  // Default position (below and to the right of cursor)
  let left = clientX;
  let top = clientY + 10;

  // Check right boundary
  if (left + popupWidth > viewportWidth) {
    // Try positioning to the left of cursor
    left = clientX - popupWidth - 10;

    // If still off-screen, align to right edge
    if (left < 0) {
      left = Math.max(10, viewportWidth - popupWidth - 10);
    }
  }

  // Check bottom boundary
  if (top + popupHeight > viewportHeight) {
    // Try positioning above cursor
    top = clientY - popupHeight - 10;

    // If still off-screen, align to fit within viewport
    if (top < 0) {
      top = Math.max(10, viewportHeight - popupHeight - 10);
    }
  }

  // Ensure minimum margins
  left = Math.max(10, Math.min(left, viewportWidth - popupWidth - 10));
  top = Math.max(10, Math.min(top, viewportHeight - popupHeight - 10));

  return {
    left: left + scrollX,
    top: top + scrollY,
  };
}
